import {useQuery} from "@tanstack/react-query";
import {Link} from "react-router-dom";
import {api} from "@/lib/api";
import {useSettings} from "@/context/SettingsContext";
import CategoryBrowser from "./CategoryBrowser";
export default function CategoryStrip(){
 const {settings:s}=useSettings();
 const {data:cats=[]}=useQuery({queryKey:["public-categories"],queryFn:({signal})=>api.get("/categories",{signal}).then(r=>r.data),staleTime:300000,retry:1});
 if(!cats.length)return null;
 return <section className="m20-container py-7" data-testid="category-strip">
  <div className="flex items-center justify-between gap-3 mb-4"><div><p className="text-[10px] uppercase tracking-[.18em] text-primary font-bold mb-1">{s?.category_kicker||"Encontre seu próximo achado"}</p><h2 className="font-display font-bold text-2xl">{s?.category_title||"Uma loja. Muitas possibilidades."}</h2></div><Link to="/produtos" className="hidden sm:block text-sm text-primary font-semibold">Ver catálogo →</Link></div>
  <CategoryBrowser categories={cats}/>
 </section>;
}
